module.exports = __webpack_public_path__ + "assets/img/import_component_default.df7d8409.jpg";